import { InfoCardSkeleton } from '~shared/ui/info-card';

export const ReviewSkeleton = () => (
  <div className="flex flex-col gap-3">
    <InfoCardSkeleton rows={8} />
    <InfoCardSkeleton rows={6} />
    <InfoCardSkeleton rows={4} />
    <InfoCardSkeleton rows={4} />
    <InfoCardSkeleton rows={2} />
  </div>
);
